module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/recruiter-insights.json
// module id = 1465
// module chunks = 144277998527046